<template>
  <div>
    <p class="text-gray-700 mb-4">
      Convite enviado. Copie o link para compartilhar diretamente.
    </p>
    <div v-for="invite in invites" :key="invite.id_invite" class="mb-4">
      <label class="form-label">{{ contactLabel(invite) }}</label>
      <div class="input-group">
        <input type="text" class="form-control" readonly :value="invite.invite_url">
        <button class="btn btn-primary" type="button" @click="copyInviteLink(invite.invite_url)">
          Copiar link
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { copyInviteLink } from "./copyInviteLink";
import strMask from "../../helpers/strMask";

export default {
  name: "InviteLinkList",
  props: {
    invites: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    copyInviteLink,
    contactLabel(invite) {
      if (invite.invite_channel === "whatsapp") {
        return strMask.it(invite.invite_phone, "(##) #####-####");
      }

      return invite.invite_email;
    },
  },
};
</script>
